import { club } from "../clubApi/schemas";
import { createEntity } from "shadow-client";
import { file } from "../fileApi/schemas";

export const product = createEntity("products", {
  publicMetadata: {
    imagePath: file
  }
});

export const offer = createEntity("offers", {});

export const productBehavior = createEntity("productBehaviors", {
  configuration: {
    clubsIncluded: [club]
  }
});



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/productApi/schemas.js